export default __webpack_public_path__ + "static/media/drag-arrow.01945f90.svg";